import { render, staticRenderFns } from "./index2_pc.vue?vue&type=template&id=52c588ee&scoped=true&"
import script from "./index2_pc.vue?vue&type=script&lang=js&"
export * from "./index2_pc.vue?vue&type=script&lang=js&"
import style0 from "./index2_pc.vue?vue&type=style&index=0&id=52c588ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c588ee",
  null
  
)

export default component.exports